module.exports = __webpack_public_path__ + "img/t3-position.91d49525.png";